<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-card class="pa-0">
        <v-card-title>
          Filter Report
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="light-background"
            @click="applyFilter"
          >
            Apply
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-container>
          <v-row dense>
            <v-col cols="12">
              <timeframe-select
                v-model="value"
                v-on:change="changeDates"
                two-lines
              ></timeframe-select>
            </v-col>
            <v-col cols="12">
              <v-select
                dense
                hide-details
                v-model="teamId"
                :items="teams"
                label="Department"
                item-text="fullName"
                item-value="id"
                @change="changeTeam"
                outlined
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" v-if="!isAnonymous">
              <member-autocomplete
                v-model="userIds"
                :multiple="false"
                label="Member"
                hide-details
                dense
              >
              </member-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Filter By Unique Sends
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <v-skeleton-loader
            v-if="loading"
            type="table-tbody"
          ></v-skeleton-loader>
          <v-data-table
            v-else
            v-model="selectedInstances"
            item-key="id"
            show-select
            :headers="headers"
            :items="formattedInstances"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
          >
            <template v-slot:item.sentDate="{ item }">
              {{ (item.scheduledDate || item.sentDate) | longDate }}
            </template>
            <template v-slot:item.completion="{ item }">
              <v-icon v-if="item.status == 'Scheduled'">remove</v-icon>
              <template v-else>
                <core-score-text
                  :score="
                    $coreScores.reverseFormat(
                      (item.userRecords || {}).completion
                    )
                  "
                ></core-score-text>
              </template>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import MemberAutocomplete from "@/components/members/MemberAutocomplete";
import CoreScoreText from "@/components/common/CoreScoreText";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
export default {
  name: "ReportingFilter",
  components: { MemberAutocomplete, CoreScoreText, TimeframeSelect },
  props: {
    value: { type: Object, required: true },
    isAnonymous: { type: Boolean, default: false }
  },
  data: () => ({
    teamId: null,
    userIds: [],
    loading: false,
    instanceIds: []
  }),
  watch: {
    "value.userId": function(val, oldVal) {
      if (val && val != oldVal) {
        this.userIds = [val];
      }
    }
  },
  computed: {
    selectedInstances: {
      get() {
        return this.instances.filter(x => this.instanceIds.indexOf(x.id) >= 0);
      },
      set(val, oldVal) {
        this.instanceIds = val.map(x => x.id);
        if (!this._.isEqual(val, oldVal)) {
          this.applyFilter();
        }
      }
    },
    formattedInstances() {
      return this.instances.filter(x => {
        return x.sentDate != null;
      });
    },
    headers() {
      let list = [{ text: "Date", value: "sentDate" }];
      list.push({ text: "Engagement", value: "completion", sortable: false });
      return list;
    },
    teams() {
      return this.all_teams;
    },
    ...mapGetters({
      all_teams: "team/teams",
      team_users: "team/team_users",
      instances: "reporting/instances"
    })
  },
  created() {
    if (this.value) {
      if (this.value.instanceIds) {
        this.instanceIds = this.value.instanceIds;
      }
      if (this.value.teamId) {
        this.teamId = this.value.teamId;
      }
      if (this.value.userId) {
        this.userIds = [this.value.userId];
      }
    }

    this.loading = true;
    Promise.all([this.$store.dispatch("team/getTeams", this.value)])
      .then(() => {
        this.changeDates();
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading report."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    applyFilter() {
      this.value.teamId = this.teamId;
      this.value.userId = this.userIds[0];
      this.value.instanceIds = this.instanceIds;
      this.$emit("change", this.value);
    },
    changeTeam() {
      this.userIds = [];
    },
    changeDates() {
      this.loading = true;
      this.$store
        .dispatch("reporting/getInstances", this.value)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-btn.light-background {
  &::before {
    opacity: 0.15;
  }

  &:hover {
    &::before {
      opacity: 0.3;
    }
  }
}
</style>
